import { formatCommentCountMagazine, WCM_COMMENTS_EVENT } from "../articleHeaderComponenta/actionBarShared"
import { isWcmEditor } from "config/serverConfig"

const siteArticleCommentsId = "SiteArticleComments"

interface CalcalistArticleHeaderV2CommentsProps {
    showComments: boolean
    isApp?: boolean
}

interface CalcalistArticleHeaderV2CommentsState {
    showComments: boolean
    wcmNumOfComments: string
}

export class CalcalistArticleHeaderV2Comments extends React.Component<CalcalistArticleHeaderV2CommentsProps, CalcalistArticleHeaderV2CommentsState> {
    public static siteScriptName = "CalcalistArticleHeaderV2Comments"

    constructor(props: CalcalistArticleHeaderV2CommentsProps) {
        super(props)
        this.state = {
            showComments: !!props.isApp && !!props.showComments,
            wcmNumOfComments: "",
        }
    }

    componentDidMount() {
        document.addEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived)
        this.setState({
            showComments: this.canShowComments(),
            wcmNumOfComments: typeof window !== "undefined" && window.wcmNumOfComments ? window.wcmNumOfComments : "",
        })
    }

    componentWillUnmount() {
        document.removeEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived)
    }

    private handleOnWcmCommentsRecived = (e: any) => {
        const wcmNumOfComments = e && e.detail && e.detail.wcmNumOfComments ? e.detail.wcmNumOfComments : ""
        this.setState({
            showComments: this.canShowComments(),
            wcmNumOfComments,
        })
    }

    private canShowComments = () => {
        if (!this.props.showComments) {
            return false
        }
        if (this.props.isApp || isWcmEditor()) {
            return true
        }
        return this.isTalkbackElement() || (typeof window !== "undefined" && !!window.handleCommentsPopupVisability)
    }

    private isTalkbackElement = () => {
        if (typeof window !== "undefined") {
            return !!document.getElementById(siteArticleCommentsId)
        }
        return false
    }

    private handleMobileClick = () => {
        if (typeof window !== "undefined" && window.handleCommentsPopupVisability) {
            window.handleCommentsPopupVisability()
            return
        }
        const commentsEl = document.getElementById(siteArticleCommentsId)
        if (commentsEl) {
            commentsEl.scrollIntoView({ behavior: "smooth" })
        }
    }

    render() {
        const { isApp } = this.props
        const { showComments, wcmNumOfComments } = this.state
        if (!showComments) {
            return null
        }

        const commentNumber = formatCommentCountMagazine(wcmNumOfComments)
        const countText = commentNumber ? commentNumber.toUpperCase() : ""
        const inner = (
            <>
                {countText && <span className="calcalistArticleHeaderV2CommentsCount">{countText}</span>}
                <span className="calcalistArticleHeaderV2CommentsTail"></span>
            </>
        )

        if (isApp) {
            return (
                <a href="#SiteArticleComments" className="calcalistArticleHeaderV2Comments" title="תגובות">
                    {inner}
                </a>
            )
        }

        return (
            <button
                type="button"
                className="calcalistArticleHeaderV2Comments"
                title="תגובות"
                onClick={this.handleMobileClick}
            >
                {inner}
            </button>
        )
    }
}
